import { formatCNPJ, formatCPF, isValidCNPJ, isValidCPF, onlyNumbers } from '@brazilian-utils/brazilian-utils'

export class Document {
  public constructor(private readonly value: string) {}

  public static build(value: string): Document {
    return new Document(onlyNumbers(value))
  }

  public isValid(): boolean {
    if (this.value.length === 14) {
      return isValidCNPJ(this.value)
    } else {
      return isValidCPF(this.value)
    }
  }

  public getValue(): string {
    if (this.value.length === 14) {
      if (this.isValid()) {
        return formatCNPJ(this.value)
      }
    } else {
      if (this.isValid()) {
        return formatCPF(this.value)
      }
    }
    return this.value
  }
}
